<template>
  <div>
    <form
      action="/Cybersourceqa/Payment/InitiateCreditCardPayment/"
      method="POST"
      ref="paymentForm"
      id="submitReq"
      name="submitReq"
    >
      <input
        type="hidden"
        name="Amwal"
        :value="formStore.paymentFormData.redirectionCardForm.encryptedMessage"
      />
    </form>
  </div>
</template>

<script setup>
import { useFormStore } from '@/stores/form'
import { onMounted } from 'vue'
import { ref } from 'vue'

const formStore = useFormStore()

const paymentForm = ref()
onMounted(() => {
  paymentForm.value.submit()
})
</script>

<script>
export default {
  name: 'FeesGateway'
}
</script>

<style lang="scss" scoped></style>
